export const FREQUENT_REQUESTS = -2 // 频繁请求
export const BACK_END_ERROR = -1 // 后端逻辑错误
export const SUCCESS = 0
export const PARAMS_ERROR = 1 // 参数错误
export const PASSWORD_ERROR = 2 // 修改密码时候密码错误
export const TOKEN_EMPTY = 50001
export const TOKEN_NO_ACCESS = 50002
export const TOKEN_ERROR = 50008
export const TOKEN_LOGIN = 50013
export const TOKEN_EXPIRATION = 50014
export const TOKEN_SIGNATURE = 50015
export const TOKEN_IGNORE_REQUEST = 50016
export const LOGIN_ERROR = 20401
export const LOGIN_ENDTIME = 20402 // 已过期
export const LOGIN_STOP = 20403 // 停用
export const NOT_ADD_WECHAT = 20405 // 未添加训练师微信
export const LOGIN_DAYOUT = 20406 // 天数已用完
export const WECHAT_UNBIND_ERROR = 20501 // 当前帐号未绑定微信
// export const WECHAT_UNFIND_ERROR = 20502 // 未找到扫描用户
// export const WECHAT_OUTMODED_ERROR = 20503 // 微信ID绑定过时
export const WECHAT_BINDED_ERROR = 20504 // 当前账户已绑定
